import React from "react";
import {
  EventLog_EventFragment,
  useGetCustomerContractEventLogQuery,
  useAddCustomerContractCommentEventMutation,
  GetCustomerContractEventLog
} from "@graphql";
import { EventLogLayout } from "@containers/EventLog/components/EventLogLayout";
import CommentBox from "../CommentBox/CommentBox";
import { Spinner } from "@common";
import { CustomerContractEvent } from "@containers/EventLog/CustomerContractEventLog/CustomerContractEvent/CustomerContractEvent";
import { store } from "@store";

type CommentBoxProps = {
  id: string;
};

function CustomerContractCommentBox(props: CommentBoxProps) {
  const { id } = props;
  const [submit] = useAddCustomerContractCommentEventMutation();
  return (
    <CommentBox
      withButtons={["comment"]}
      skipReminder
      onComment={(data, reminder, form) => {
        return submit({
          variables: {
            customerContractId: id,
            eventLog: {
              _id: null,
              description: data.text,
              sticky: false
            }
          },
          refetchQueries: [GetCustomerContractEventLog.OperationName]
        })
          .then((res) => {
            // TODO: snack bar for events
            console.log("Event Added", res);
            // store().snackbars.success(locale.);
          })
          .catch((err) => {
            store().snackbars.error(err);
          })
          .finally(() => form.setSubmitting(false));
      }}
    />
  );
}

type EventProps = {
  events: EventLog_EventFragment[];
  customerContractId: string;
};
function EventList(props: EventProps) {
  const { events, customerContractId } = props;
  return (
    <>
      {events.map((x) => (
        <div key={x._id}>
          <CustomerContractEvent customerContractId={customerContractId} event={x} />
        </div>
      ))}
    </>
  );
}

type Props = {
  id: string;
};

export function CustomerContractEventLog(props: Props) {
  const { id } = props;

  const { data, error, loading } = useGetCustomerContractEventLogQuery({
    variables: {
      customerContractId: id
    }
  });

  if (loading) {
    return <Spinner fullHeight />;
  }

  if (error) {
    return <div>{error.toString()}</div>;
  }

  return (
    <div>
      <EventLogLayout
        commentBox={<CustomerContractCommentBox id={id} />}
        list={
          <EventList
            customerContractId={id}
            events={data.customerContractById.eventLogs}
          />
        }
        search=""
      />
    </div>
  );
}
